import { Box, Container, Stack, Typography } from "@mui/material";
import { Seo } from "src/components/seo";
import { brandConfig } from "src/config/brand";
import { usePageView } from "src/hooks/use-page-view";
import {
  privacyPolicy,
  TermsSectionList,
  termsOfService,
} from "src/pages/auth/jwt/terms-dialog";

const LEGAL_CONTENT = {
  terms: {
    title: "서비스 이용약관",
    sections: termsOfService,
  },
  privacy: {
    title: "개인정보처리방침",
    sections: privacyPolicy,
  },
};

const LegalPage = ({ type }) => {
  usePageView();

  const content = LEGAL_CONTENT[type];

  return (
    <>
      <Seo title={`${content.title} | ${brandConfig.name}`} />
      <Box
        component="main"
        sx={{ py: { xs: 6, md: 10 } }}
      >
        <Container maxWidth="md">
          <Stack spacing={4}>
            <Box>
              <Typography
                component="h1"
                variant="h3"
              >
                {content.title}
              </Typography>
              <Typography
                color="text.secondary"
                sx={{ mt: 1 }}
                variant="body2"
              >
                {brandConfig.name} 서비스에 적용되는 {content.title}입니다.
              </Typography>
            </Box>
            <TermsSectionList sections={content.sections} />
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default LegalPage;
